export default __webpack_public_path__ + "static/media/10-face-with-diagonal-mouth_1fae4.2eec8dbb.png";